import React, { useEffect } from 'react';
import { ErrorState } from '../../../components/states';
import TermsForm from '../../../components/forms/TermsForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function TermsPage() {
  const { requestApi, data, error } = useFetch(`/v1/settings`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <TermsForm defaultValues={data?.data} /> : <Loader />;
}
